import { createContext } from 'react'

type AosTokenContextValue = {
  token: string | null
  expiry: string | null
  setToken: (value: string | null) => void
  setExpiry: (value: string | null) => void
}
export const AosTokenContext = createContext<AosTokenContextValue>({
  token: null,
  expiry: null,
  setToken: () => {},
  setExpiry: () => {},
})
